import React from "react";
import { EngagementCard } from "./card";
import {Route as dashboardRoute} from "@/routes/(inventory)/branch/_layout/dashboard/index";
import { convertToCurrencyRounded } from "@/utils/currency_converter";

const InventoryEngagement = () => {

  const data = dashboardRoute.useLoaderData();
  const inventoryOverview = data.inventoryOverview.branchLevelView!;

  const engagementData: {
    title: string;
    name: string;
    description: string;
    linkText: string;
    link: string;
  }[] = []

  engagementData.push({
    title: "Dead Stock",
    name: `
      ${inventoryOverview.expiringSoonItems+inventoryOverview.expiredItems} items
    `,
    description: "Items that are about to expire or have already expired.",
    linkText: "View Dead Stock",
    link: "/branch/inventory/available-inventory/?expiring_in_30_days=true"
  })

  engagementData.push({
    title: "Out of Stock",
    name: `${inventoryOverview.outOfStockItems} items`,
    description: "Items that are out of stock.",
    linkText: "View Out of Stock",
    link: "/branch/reports/out-of-stock"
  });

  if (inventoryOverview.fastMovingItems.length > 0) {
    engagementData.push({
      title: "High Demand",
      name: `${inventoryOverview.fastMovingItems[0].tradeName}`,
      description: "Items that are in high demand.",
      linkText: "View High Demand",
      link: "/branch/reports/fast-moving-items/"
    })
  }

  if (inventoryOverview.slowMovingItems.length > 0) {
    engagementData.push({
      title: "Low Demand",
      name: `${inventoryOverview.slowMovingItems[0].tradeName}`,
      description: "Items that are in low demand.",
      linkText: "View Low Demand",
      link: "/branch/reports/slow-moving-items/"
    })
  }

  engagementData.push({
    title: "Total Inventory Value",
    name: `${convertToCurrencyRounded(inventoryOverview.totalInventoryValue!)}`,
    description: "Total value of all items in the inventory.",
    linkText: "View Inventory Value",
    link: "/branch/inventory/available-inventory/"
  })

  const totalItems = engagementData.length;
  const cols = 3;

  const getItemClassName = (index: number) => {
    const itemsInLastRow = totalItems % cols;

    if (itemsInLastRow === 0) {
      return "";
    }

    const isLastRow = index >= totalItems - itemsInLastRow;

    if (!isLastRow) {
      return "";
    }

    if (itemsInLastRow === 1) {
      return "md:col-span-3";
    }

    if (itemsInLastRow === 2 && index === totalItems - 1) {
      return "md:col-span-2";
    }

    return "";
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {engagementData.map((item, index) => (
        <div key={index} className={getItemClassName(index)}>
          <EngagementCard {...item} />
        </div>
      ))}
    </div>
  );
};

export default InventoryEngagement;